/**
 * Módulo de Descontos
 * Responsável por todas as funcionalidades relacionadas a descontos em produtos, serviços e totais
 */

import { formataValorMonetario } from "../../utils/common.js";

/**
 * Inicializa o módulo de descontos
 */
export function initDiscountsModule() {
    initDiscountMasks();
    initDiscountEvents();
    initDiscountCalculations();
}

/**
 * Inicializa máscaras de desconto
 */
function initDiscountMasks() {
    // Inicializar máscaras para descontos gerais de produtos
    const $discountInputProducts = $("#discountInputProducts");
    if ($discountInputProducts.length) {
        if ($discountInputProducts.hasClass("valorMask")) {
            $("#discountByValueProducts").prop("disabled", false);
            $("#discountAllProducts").prop("disabled", true);
        } else {
            $("#discountByValueProducts").prop("disabled", true);
            $("#discountAllProducts").prop("disabled", false);
        }
    }

    // Inicializar máscaras para descontos gerais de serviços
    const $discountInputServices = $("#discountInputServices");
    if ($discountInputServices.length) {
        if ($discountInputServices.hasClass("valorMask")) {
            $("#discountByValueServices").prop("disabled", false);
            $("#discountAllServices").prop("disabled", true);
        } else {
            $("#discountByValueServices").prop("disabled", true);
            $("#discountAllServices").prop("disabled", false);
        }
    }

    // Inicializar máscaras para desconto total
    const $discountInputTotal = $("#discountTotalInput");
    if ($discountInputTotal.length) {
        if ($discountInputTotal.hasClass("valorMask")) {
            $("#fullDiscountByValue").prop("disabled", false);
            $("#fullDiscount").prop("disabled", true);
        } else {
            $("#fullDiscountByValue").prop("disabled", true);
            $("#fullDiscount").prop("disabled", false);
        }
    }
}

/**
 * Inicializa eventos de desconto
 */
function initDiscountEvents() {
    // Eventos para botões de desconto total (R$ e %)
    $(document).on("click", "#discount-total-value, #discount-total-percent", function (e) {
        e.preventDefault();
        const isValue = $(this).attr("id") === "discount-total-value";
        const $input = $("#discountTotalInput");
        const $container = $(this).closest(".switch-select");

        // Remove active de todos os botões
        $container.find(".switch-select__btn").removeClass("switch-select__btn--active");
        // Adiciona active ao botão clicado
        $(this).addClass("switch-select__btn--active");

        // Preservar o valor atual do input
        const currentValue = $input.val();

        if (isValue) {
            $input.removeClass("percent").addClass("valorMask");
            $input.attr("placeholder", "0,00");
            $("#fullDiscountByValue").prop("disabled", false);
            $("#fullDiscount").prop("disabled", true);

            // Transferir valor do campo percentual para valor se houver
            const percentValue = $("#fullDiscount").val();
            if (percentValue && percentValue.trim() !== "" && percentValue !== "0%") {
                // Calcular valor baseado no percentual
                const totalGeral = parseFloat($("#valueOriginalOS").val()) || 0;
                const percent = parseFloat(percentValue.replace('%', '').replace(',', '.')) || 0;
                if (percent > 0 && totalGeral > 0) {
                    const valorDesconto = (totalGeral * percent) / 100;
                    $("#fullDiscountByValue").val(valorDesconto.toFixed(2).replace('.', ','));
                }
            }
            $("#fullDiscount").val("");
        } else {
            $input.removeClass("valorMask").addClass("percent");
            $input.attr("placeholder", "0%");
            $("#fullDiscountByValue").prop("disabled", true);
            $("#fullDiscount").prop("disabled", false);

            // Transferir valor do campo valor para percentual se houver
            const valueAmount = $("#fullDiscountByValue").val();
            if (valueAmount && valueAmount.trim() !== "" && valueAmount !== "0,00") {
                // Calcular percentual baseado no valor
                const totalGeral = parseFloat($("#valueOriginalOS").val()) || 0;
                const valor = parseFloat(valueAmount.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
                if (valor > 0 && totalGeral > 0) {
                    const percent = (valor * 100) / totalGeral;
                    $("#fullDiscount").val(percent.toFixed(2).replace('.', ',') + '%');
                }
            }
            $("#fullDiscountByValue").val("");
        }

        // Limpar o campo ao alternar entre $ e %
        $input.val("");

        // Só recalcular se realmente houve mudança nos campos ocultos
        calculaTotais();
    });

    // Eventos para botões de desconto geral de serviços (R$ e %)
    $(document).on("click", "button[data-target='services']", function (e) {
        e.preventDefault();
        const isValue = $(this).data("type") === "value";
        const $input = $("#discountInputServices");
        const $container = $(this).closest(".switch-select");

        // Remove active de todos os botões
        $container.find(".switch-select__btn").removeClass("switch-select__btn--active");
        // Adiciona active ao botão clicado
        $(this).addClass("switch-select__btn--active");

        // Preservar o valor atual do input
        const currentValue = $input.val();

        if (isValue) {
            $input.removeClass("percent").addClass("valorMask");
            $input.attr("placeholder", "0,00");
            $("#discountByValueServices").prop("disabled", false);
            $("#discountAllServices").prop("disabled", true);

            // Limpar ambos os campos hidden ao alternar
            $("#discountAllServices").val("");
            $("#discountByValueServices").val("");
        } else {
            $input.removeClass("valorMask").addClass("percent");
            $input.attr("placeholder", "0%");
            $("#discountByValueServices").prop("disabled", true);
            $("#discountAllServices").prop("disabled", false);

            // Limpar ambos os campos hidden ao alternar
            $("#discountByValueServices").val("");
            $("#discountAllServices").val("");
        }

        // Limpar o campo ao alternar entre $ e %
        $input.val("");

        calculaTotais();
    });

    // Eventos para botões de desconto geral de produtos (R$ e %)
    $(document).on("click", "button[data-target='products']", function (e) {
        e.preventDefault();
        const isValue = $(this).data("type") === "value";
        const $input = $("#discountInputProducts");
        const $container = $(this).closest(".switch-select");

        // Remove active de todos os botões
        $container.find(".switch-select__btn").removeClass("switch-select__btn--active");
        // Adiciona active ao botão clicado
        $(this).addClass("switch-select__btn--active");

        // Preservar o valor atual do input
        const currentValue = $input.val();

        if (isValue) {
            $input.removeClass("percent").addClass("valorMask");
            $input.attr("placeholder", "0,00");
            $("#discountByValueProducts").prop("disabled", false);
            $("#discountAllProducts").prop("disabled", true);

            // Limpar ambos os campos hidden ao alternar
            $("#discountAllProducts").val("");
            $("#discountByValueProducts").val("");
        } else {
            $input.removeClass("valorMask").addClass("percent");
            $input.attr("placeholder", "0%");
            $("#discountByValueProducts").prop("disabled", true);
            $("#discountAllProducts").prop("disabled", false);

            // Limpar ambos os campos hidden ao alternar
            $("#discountByValueProducts").val("");
            $("#discountAllProducts").val("");
        }

        // Limpar o campo ao alternar entre $ e %
        $input.val("");

        calculaTotais();
    });

    // Eventos para botões de desconto por linha de produto (R$ e %)
    $(document).on("click", "button[data-hash][data-type]", function (e) {
        e.preventDefault();
        const hash = $(this).data("hash");
        const isValue = $(this).data("type") === "value";
        const $input = $(`#discountInput${hash}`);
        const $container = $(this).closest(".switch-select");
        const $valueField = $(`#discountByValue${hash}`);
        const $percentField = $(`#discount${hash}`);

        // Remove active de todos os botões do container
        $container.find(".switch-select__btn").removeClass("switch-select__btn--active");
        // Adiciona active ao botão clicado
        $(this).addClass("switch-select__btn--active");

        if (isValue) {
            $input.removeClass("percent").addClass("valorMask");
            $input.attr("placeholder", "0,00");
            // Reinicializa a máscara para valor monetário
            if (typeof $input.unmask === 'function') {
                $input.unmask();
            }
            if (typeof $input.mask === 'function') {
                $input.mask("#.##0,00", {
                    reverse: true,
                    placeholder: "0,00"
                });
            }
            $percentField.prop("disabled", true).val("");
            $valueField.prop("disabled", false);
        } else {
            $input.removeClass("valorMask").addClass("percent");
            $input.attr("placeholder", "0%");
            // Reinicializa a máscara para percentual
            if (typeof $input.unmask === 'function') {
                $input.unmask();
            }
            if (typeof $input.mask === 'function') {
                $input.mask("##0%", { reverse: true, placeholder: "0%" });
            }
            $valueField.prop("disabled", true).val("");
            $percentField.prop("disabled", false);
        }

        // Sempre limpar o input ao alternar entre tipos
        $input.val("");

        calculaTotais();
    });
}

/**
 * Inicializa cálculos de desconto
 */
function initDiscountCalculations() {
    // Controle do interruptor de desconto para itens individuais
    $(document).on("change", "#discount-value, #discount-percent", function () {
        const hash = $(this).data("hash");
        const $input = $(`#discountInput${hash}`);
        const $valueField = $(`#discountByValue${hash}`);
        const $percentField = $(`#discount${hash}`);

        if ($(this).attr("id") === "discount-value") {
            $input.removeClass("percentMask").addClass("valorMask");
            $input.attr("placeholder", "0,00");
            if (typeof $input.unmask === 'function') {
                $input.unmask();
            }
            if (typeof $input.mask === 'function') {
                $input.mask("#.##0,00", {
                    reverse: true,
                    placeholder: "0,00",
                });
            }
            $percentField.prop("disabled", true);
            $valueField.prop("disabled", false);
        } else {
            $input.removeClass("valorMask").addClass("percentMask");
            $input.attr("placeholder", "0%");
            if (typeof $input.unmask === 'function') {
                $input.unmask();
            }
            $input.mask("##0%", { reverse: true, placeholder: "0%" });
            $valueField.prop("disabled", true);
            $percentField.prop("disabled", false);
        }

        $input.val("");
        $valueField.val("");
        $percentField.val("");
        calculaTotais();
    });

    // Controle do input de desconto unificado para itens individuais
    $(document).on("input", ".discount-input", function () {
        const hash = $(this).data("hash");
        const valor = $(this).val();
        const isValue = $(this).hasClass("valorMask");
        const $valueField = $(`#discountByValue${hash}`);
        const $percentField = $(`#discount${hash}`);

        if (valor && valor.trim() !== "") {
            if (isValue) {
                // Desconto por valor - atualizar campo oculto de valor
                const valorLimpo = valor.replace(/[^\d,]/g, '').replace(',', '.');
                $valueField.val(valorLimpo);
                $percentField.val("");
                calculaDescontoPorValor(valor, hash);
            } else {
                // Desconto por percentual - atualizar campo oculto de percentual
                const percentLimpo = valor.replace('%', '').replace(',', '.');
                $percentField.val(percentLimpo);
                $valueField.val("");
                calculaDesconto(valor, hash);
            }
        } else {
            // Limpar ambos os campos se o input estiver vazio
            $valueField.val("");
            $percentField.val("");
        }

        calculaTotais();
    });

    // Evento para campo de desconto geral de produtos
    $(document).on("input", "#discountInputProducts", function () {
        const valor = $(this).val();
        const isValue = $(this).hasClass("valorMask");

        if (valor && valor.trim() !== "") {
            if (isValue) {
                // Desconto por valor - atualizar campo oculto de valor
                const valorLimpo = valor.replace(/[^\d,]/g, '').replace(',', '.');
                $("#discountByValueProducts").val(valorLimpo);
                $("#discountAllProducts").val("");
            } else {
                // Desconto por percentual - atualizar campo oculto de percentual
                const percentLimpo = valor.replace('%', '').replace(',', '.');
                $("#discountAllProducts").val(percentLimpo);
                $("#discountByValueProducts").val("");
            }
        } else {
            // Limpar ambos os campos se o input estiver vazio
            $("#discountByValueProducts").val("");
            $("#discountAllProducts").val("");
        }

        calculaTotais();
    });

    // Evento para campo de desconto geral de serviços
    $(document).on("input", "#discountInputServices", function () {
        const valor = $(this).val();
        const isValue = $(this).hasClass("valorMask");

        if (valor && valor.trim() !== "") {
            if (isValue) {
                // Desconto por valor - atualizar campo oculto de valor
                const valorLimpo = valor.replace(/[^\d,]/g, '').replace(',', '.');
                $("#discountByValueServices").val(valorLimpo);
                $("#discountAllServices").val("");
            } else {
                // Desconto por percentual - atualizar campo oculto de percentual
                const percentLimpo = valor.replace('%', '').replace(',', '.');
                $("#discountAllServices").val(percentLimpo);
                $("#discountByValueServices").val("");
            }
        } else {
            // Limpar ambos os campos se o input estiver vazio
            $("#discountByValueServices").val("");
            $("#discountAllServices").val("");
        }

        calculaTotais();
    });

    // Outros eventos de desconto
    initOtherDiscountEvents();
}

/**
 * Inicializa outros eventos de desconto
 */
function initOtherDiscountEvents() {
    // Eventos para recálculo automático em campos individuais
    $(document).on("input", "input[name*='quantity'], input[name*='unit_price'], input[class*='discount-input']", function () {
        calculaTotais();
    });

    // Eventos para campos de quantidade e preço unitário
    $(document).on("input", ".quantity-input, .price-input", function () {
        calculaTotais();
    });

    // Eventos específicos para campos de produto (classes do template)
    $(document).on("input", ".qtdItem, .priceItem, .costPrice, .discount-input", function () {
        calculaTotais();
    });

    // Eventos para inputs de desconto por hash
    $(document).on("input", "input[data-hash]", function () {
        const hash = $(this).data('hash');
        if (hash) {
            calculaTotais();
        }
    });

    // Eventos para campos de serviço também
    $(document).on("input", ".service-item-qty, .service-item-price", function () {
        calculaTotais();
    });

    // Eventos adicionais para garantir recálculo em todos os campos relevantes
    $(document).on("input change", "input[id*='qtd'], input[id*='price'], input[id*='preco']", function () {
        calculaTotais();
    });

    // Eventos para campos com máscara de valor
    $(document).on("input change", ".valorMask", function () {
        calculaTotais();
    });

    // Eventos para campos de quantidade específicos
    $(document).on("input change", "input[name*='qtd'], input[name*='preco'], input[name*='custo']", function () {
        calculaTotais();
    });

    // Desconto total produtos
    $(document).on("input", "#discountAllProducts", function () {
        let desconto = $(this).val().trim();

        if (desconto !== "" && desconto !== "%") {
            calculaTotais();
        } else {
            $("#discountByValueProducts").val("");
            $("#discountAllProducts").val("");
            calculaTotais();
        }
    });

    // Desconto por valor total produtos
    $(document).on("input", "#discountByValueProducts", function () {
        const subtotal =
            parseFloat(
                $("#subtotalProdutos")
                    .text()
                    .replace(/[^\d,]/g, "")
                    .replace(",", ".")
            ) || 0;
        let valorDesconto = $(this)
            .val()
            .replace(/[^\d,]/g, "")
            .replace(",", ".");

        if (valorDesconto && valorDesconto.trim() !== "") {
            valorDesconto = parseFloat(valorDesconto);
            if (valorDesconto > 0 && subtotal > 0) {
                let desconto = (valorDesconto * 100) / subtotal;
                $("#discountAllProducts").val(
                    formataValorMonetario(desconto) + "%"
                );
            }
        } else {
            $("#discountAllProducts").val("");
        }
        calculaTotais();
    });

    // Desconto total serviços
    $(document).on("input", "#discountAllServices", function () {
        let desconto = $(this).val();

        if (desconto !== "" && desconto !== "%") {
            calculaTotais();
        } else {
            $("#discountByValueServices").val("");
            $("#discountAllServices").val("");
            calculaTotais();
        }
    });

    // Desconto por valor total serviços
    $(document).on("input", "#discountByValueServices", function () {
        const subtotal =
            parseFloat(
                $("#subtotalServicos")
                    .text()
                    .replace(/[^\d,]/g, "")
                    .replace(",", ".")
            ) || 0;
        let valorDesconto =
            parseFloat(
                $(this)
                    .val()
                    .replace(/[^\d,]/g, "")
                    .replace(",", ".")
            ) || 0;

        if (valorDesconto > 0) {
            if (subtotal > 0) {
                let desconto = (valorDesconto * 100) / subtotal;
                $("#discountAllServices").val(
                    formataValorMonetario(desconto) + "%"
                );
            }
        } else {
            $("#discountAllServices").val("");
        }
        calculaTotais();
    });

    // Desconto total OS
    $(document).on("input", "#fullDiscount", function () {
        const desconto = $(this).val().replace("%", "").trim();

        if (desconto !== "" && !isNaN(parseFloat(desconto))) {
            const percentValue = parseFloat(desconto);
            if (percentValue > 0) {
                // Apenas armazenar o valor, deixar calculaTotais() fazer os cálculos
                $(this).val(percentValue.toFixed(2).replace('.', ',') + '%');
            }
        }

        // Chamar calculaTotais para recalcular tudo corretamente
        calculaTotais();
    });

    // Desconto total OS por valor
    $(document).on("input", "#fullDiscountByValue", function () {
        const valorDesconto = $(this).val().replace(/[^\d,]/g, "").replace(",", ".");

        if (valorDesconto && valorDesconto.trim() !== "" && !isNaN(parseFloat(valorDesconto))) {
            const valor = parseFloat(valorDesconto);
            if (valor > 0) {
                // Apenas formatar o valor, deixar calculaTotais() fazer os cálculos
                $(this).val(valor.toFixed(2).replace('.', ','));
            }
        }

        // Chamar calculaTotais para recalcular tudo corretamente
        calculaTotais();
    });

    // Evento para campo de desconto total da OS (input unificado)
    $(document).on("input", "#discountTotalInput", function () {
        const valor = $(this).val();
        const isValue = $(this).hasClass("valorMask");

        if (valor && valor.trim() !== "") {
            if (isValue) {
                // Desconto por valor - atualizar campo oculto de valor
                const valorLimpo = valor.replace(/[^\d,]/g, '').replace(',', '.');
                $("#fullDiscountByValue").val(valorLimpo);
                $("#fullDiscount").val("");
            } else {
                // Desconto por percentual - atualizar campo oculto de percentual
                const percentLimpo = valor.replace('%', '').replace(',', '.');
                $("#fullDiscount").val(percentLimpo);
                $("#fullDiscountByValue").val("");
            }
        } else {
            // Limpar ambos os campos se o input estiver vazio
            $("#fullDiscountByValue").val("");
            $("#fullDiscount").val("");
        }

        calculaTotais();
    });
}

/**
 * Calcula desconto por percentual
 * @param {string} desconto - Valor do desconto em percentual
 * @param {string} hash - Hash do item
 */
export function calculaDesconto(desconto, hash) {
    const precoVal = $(`#price${hash}`).val() || "0";
    const preco = parseFloat(
        precoVal
            .replace(/[^\d,]/g, "")
            .replace(",", ".")
    );
    const quantidade = parseFloat($(`#qtd${hash}`).val()) || 1;
    const valorT = preco * quantidade;

    const descFormat = parseFloat(
        desconto && desconto !== "" && desconto !== "%" ? desconto.replace("%", "") : "0"
    );

    const valorFinal = valorT - valorT * (descFormat / 100);
    let valorDesconto = valorT * (descFormat / 100);
    valorDesconto = desconto !== "" ? formataValorMonetario(valorDesconto) : "";

    $(`#valorFinal${hash}`).text(formataValorMonetario(valorFinal));
    $(`#valorTotal${hash}`).val(valorFinal);
    $(`#discountByValue${hash}`).val(valorDesconto);
    calculaTotais();
}

/**
 * Calcula desconto por valor
 * @param {string} valor - Valor do desconto
 * @param {string} hash - Hash do item
 */
export function calculaDescontoPorValor(valor, hash) {
    const precoVal = $(`#price${hash}`).val() || "0";
    const preco = parseFloat(
        precoVal
            .replace(/[^\d,]/g, "")
            .replace(",", ".")
    );
    const quantidade = parseFloat($(`#qtd${hash}`).val()) || 1;
    const precoTotal = preco * quantidade;

    let valorDesconto = parseFloat(
        (valor || "0").replace(/[^\d,]/g, "").replace(",", ".")
    );
    let desconto = 0;
    let valorFinal = precoTotal;

    if (valor && valor.trim() !== "" && valor !== "0,00") {
        if (valorDesconto > 0) {
            // Fórmula correta: (Vl.Venda * Qtd) - Desconto
            valorFinal = precoTotal - valorDesconto;
            // Calcula o percentual baseado no valor total
            desconto = (valorDesconto * 100) / precoTotal;
        } else {
            desconto = 0;
            valorFinal = precoTotal;
        }
    }

    desconto = valor !== "0,00" ? formataValorMonetario(desconto) + "%" : "";

    $(`#valorFinal${hash}`).text(formataValorMonetario(valorFinal));
    $(`#valorTotal${hash}`).val(valorFinal);
    $(`#discount${hash}`).val(desconto);
    $(`#discountByValue${hash}`).val(formataValorMonetario(valorDesconto));
    calculaTotais();
}

/**
 * Calcula porcentagem
 * @param {number} preco - Preço do item
 * @param {number} quantidade - Quantidade do item
 * @param {number} desconto - Desconto em percentual
 * @returns {number} Valor com desconto aplicado
 */
export function calculaPorcentagem(preco, quantidade, desconto) {
    const valor = preco * quantidade;
    let desc = (valor * desconto) / 100;
    return valor - desc;
}

/**
 * Função auxiliar para tratar valores de desconto
 * @param {string} valor - Valor a ser tratado
 * @returns {number} Valor numérico tratado
 */
const trataDesconto = (valor) => {
    if (!valor || valor.trim() === "") return 0;

    // Remove caracteres não numéricos exceto vírgula
    let valorLimpo = valor.replace(/[^\d,]/g, "");

    // Converte vírgula para ponto
    valorLimpo = valorLimpo.replace(",", ".");

    return parseFloat(valorLimpo) || 0;
};

/**
 * Calcula totais com descontos aplicados
 */
export function calculaTotais() {
    // Verifica se existe uma instância do ServiceOrderFormManager
    if (window.serviceOrderFormManager && typeof window.serviceOrderFormManager.calculateTotals === 'function') {
        window.serviceOrderFormManager.calculateTotals();
    } else if (window.ServiceOrdersEdit && typeof window.ServiceOrdersEdit.calculaTotais === 'function') {
        window.ServiceOrdersEdit.calculaTotais();
    } else if (window.serviceOrderEdit && typeof window.serviceOrderEdit.calculaTotais === 'function') {
        // Fallback para compatibilidade
        window.serviceOrderEdit.calculaTotais();
    } else {
        // Fallback para cálculo básico se não houver instância

        // Dispara evento customizado para que outros módulos possam reagir
        $(document).trigger("totalsCalculated");
    }
}
